/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

interface OptionsProps {
    label: string;
    value: string;
}
interface ButtonToggleProps {
    active: string;
    action: any;
    subAction?: any;
    options: OptionsProps[];

}
interface StyledSwitchProps {
    readonly active?: boolean;
}
const StyledSwitch = styled.button<StyledSwitchProps>`
    ${({ active, theme }) => css`
        width: 64px;
        height: 32px;
        background-color: rgba(0, 159, 227, 0.8);
        color: #fff;
        border: 0;
        line-height: 32px;
        text-align: center;

        ${active &&
        css`
            background-color: ${theme.colors.alt};
        `}
    `}
`;

const StyledSwitchWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;
    margin-left: auto;
    border-radius: 3px;
    overflow: hidden;
`;
const ButtonToggle: FC<ButtonToggleProps> = ({ active, action, options, subAction }) => {

    const handleAction = (value) => {
        action(value)
        if(subAction) {
            subAction(undefined);
        }
    }
    return (
    <StyledSwitchWrap>
        {options.length >= 1 &&
            options.map(({ label, value }, index) => (
                <StyledSwitch type="button" key={index} active={active === value} onClick={() => handleAction(value)}>
                    {label}
                </StyledSwitch>
            ))}
    </StyledSwitchWrap>
)};

export default ButtonToggle;
